export const writingAssistantConstantes = Object.freeze({
  MAX_QUESTIONS: 3,
  MAX_ATTEMPTS: 3,
  LENGTH_THRESHOLDS: Object.freeze([30, 80, 150]),
  MIN_DELTA: 20,
  DEBOUNCE_DELAY: 1000,
  RESET_DELAY_MINUTES: 20,
  MS_PER_MINUTE: 60000,
  REQUEST_TIMEOUT: 30000,
  QUOTA_TIMEOUT: 5000,
  PAUSE_KEY_SEPARATOR: ":",
  AI_ASSISTANT_DATA_ATTR: "ai-assistant-data",
  FIELD_TYPES: Object.freeze(["contexte", "taches", "difficultes", "resultats", "apprentissages"]),
});
